import React from 'react';
import '../Session/CommonContainerStrips.scss';

/** @import { CommonContainerStripsProps } from "./LoginTypes" */

const CommonContainerStrips = (/** @type {{propData: CommonContainerStripsProps}} */  props)  => {
    const { bottomLeftImg, topRightImg, children } = props.propData;
  return (
      <div className="commonContainerStrips__container" style={{ height: '100%', width: '100%', backgroundColor: 'white' }}>
        <img src={bottomLeftImg} alt="Bottom Left" className="commonContainerStrips__bottom-left" />
        <img src={topRightImg} alt="Top Right" className="commonContainerStrips__top-right" />
        <div className="commonContainerStrips__content" style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          {children}
        </div>
      </div>
  );
};

export default CommonContainerStrips;